import React from 'react'
import { Accordion, AccordionSummary, AccordionDetails, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const SAMPLERS = [
  'DDIM', 'k_dpm_2_a', 'k_dpm_2', 'k_dpm_adaptive', 'k_dpm_fast',
  'k_dpmpp_2m', 'k_dpmpp_2s_a', 'k_dpmpp_sde', 'k_euler_a', 'k_euler',
  'k_heun', 'k_lms', 'lcm'
]

interface SamplerSelectorProps {
  selectedSampler: string
  onChange: (sampler: string) => void
}

export const SamplerSelector = React.memo(function SamplerSelector({ selectedSampler, onChange }: SamplerSelectorProps) {
  return (
    <Accordion sx={{ mb: 2 }} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Select Sampler</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <RadioGroup value={selectedSampler} onChange={e => onChange(e.target.value)}>
          {SAMPLERS.map(s => (
            <FormControlLabel key={s} value={s} control={<Radio />} label={s} />
          ))}
        </RadioGroup>
      </AccordionDetails>
    </Accordion>
  )
})
